import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ToasterService } from "angular2-toaster";
import { ApiService } from "../../services/api.service";

@Component({
  selector: "app-appversion",
  templateUrl: "./appversion.component.html",
  styleUrls: ["./appversion.component.css"],
})
export class AppversionComponent implements OnInit {
  horizontalStepperStep1: FormGroup;
  formBuilder: any;
  finalSiteData: any = {};
  dataSave: any;
  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.horizontalStepperStep1 = this.fb.group({
      staffios: ["",[Validators.required,this.noWhitespaceValidator]],
      staffandroid: ["",[Validators.required,this.noWhitespaceValidator]],
      staffForceUpdate: ["0"], //0 for nothing, 1 for optional and 2 for hardcore update
      managerios: ["",[Validators.required,this.noWhitespaceValidator]],
      managerandroid: ["",[Validators.required,this.noWhitespaceValidator]],
      managerForceUpdate: ["0"], //0 for nothing, 1 for optional and 2 for hardcore update
      message: [""],
    });
    this.getVersion();
  }
  getVersion() {
    this.apiService.getVersion().subscribe((response:any) => {
      if (response["statusCode"] == 200 || response["statusCode"] == 201) {
        this.dataSave = response.data;
        this.horizontalStepperStep1.patchValue({
          staffios: this.dataSave.staffApp.IOS,
          staffandroid: this.dataSave.staffApp.ANDROID,
          staffForceUpdate: this.dataSave.staffApp.forceUpdate,
          managerios: this.dataSave.managerApp.IOS,
          managerandroid: this.dataSave.managerApp.ANDROID,
          managerForceUpdate: this.dataSave.managerApp.forceUpdate,
        });
      }
    });
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
    // console.log(isWhitespace);
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  updateVersion() {
    if(this.horizontalStepperStep1.status == "INVALID"){
        this.toasterService.pop("error","Please fill the required information")
        return;
    }
    let payload: any = {
      _id: this.dataSave._id,
      staffApp: {
        IOS: this.horizontalStepperStep1.controls.staffios.value,
        ANDROID: this.horizontalStepperStep1.controls.staffandroid.value,
        forceUpdate: this.horizontalStepperStep1.controls.staffForceUpdate.value
      },
      managerApp: {
        IOS: this.horizontalStepperStep1.controls.managerios.value,
        ANDROID: this.horizontalStepperStep1.controls.managerandroid.value,
        forceUpdate: this.horizontalStepperStep1.controls.managerForceUpdate.value
      },
    };
    console.log(payload);
    this.apiService.updateVersion(payload).subscribe((response) => {
        if (response["statusCode"] == 200 || response["statusCode"] == 201) {
          this.toasterService.pop("success", response["message"]);
          console.log(response["message"]);
          this.getVersion();
        }
      },
      (error) => {
        this.toasterService.pop(
        "error",  JSON.parse(error._body).error, JSON.parse(error._body).message
        );
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/appversion/appversion.component.ts